<template>
  <c-container>
    <c-checkout-progress />
    <c-type-switcher />

    <c-visitor-info class="mb-spacing">
      <template #title>
        {{ getLabel('introduction.miwula_yullbe_head') }}
      </template>

      <template #introduction>
        <div
          class="visitor-info__introduction"
          v-html="getLabel('introduction.miwula_yullbe')"
        />
      </template>

      <template
        v-if="ticketNumber"
        #footer
      >
        <c-action
          color="primary-inverse-dark"
          @click="showTickets"
        >
          {{ $t('availability') }}
          <c-icon
            type="chevron-right"
            :size="0.75"
          />
        </c-action>
      </template>
    </c-visitor-info>

    <transition name="transition-fade">
      <c-yullbe-selection
        v-show="$store.state.showTicketSelection"
      />
    </transition>

    <transition name="transition-fade">
      <c-payment-methods v-if="!IS_IE && !$store.state.showTicketSelection">
        <span>{{ $t('availablePaymentOptions') }}</span>
      </c-payment-methods>
    </transition>
  </c-container>
</template>

<script>
import CAction from '../components/action.vue'
import CCheckoutProgress from '../components/checkoutProgress.vue'
import CContainer from '../components/container.vue'
import CIcon from '../components/icon.vue'
import CPaymentMethods from '../components/paymentMethods.vue'
import CTypeSwitcher from '../components/typeSwitcher.vue'
import CVisitorInfo from '../components/visitorInfo.vue'
import CYullbeSelection from '../components/yullbeSelection.vue'

import api from '../api.js'
import dateHelper from '../functions/dateHelper.js'
import labelMixin from '../mixins/label.js'
import scrollToArrivalTime from '../functions/scrollToArrivalTime.js'

import { IS_IE, GAP_GIFT_CARD } from '../settings.js'

export default {
  name: 'VBookingYullbe',

  components: {
    CAction,
    CCheckoutProgress,
    CContainer,
    CIcon,
    CPaymentMethods,
    CTypeSwitcher,
    CVisitorInfo,
    CYullbeSelection
  },

  mixins: [labelMixin],

  data () {
    return {
      tracked: false
    }
  },

  computed: {
    IS_IE: () => IS_IE,
    ticketNumber () {
      return this.$store.state.selectedTicketsAmount
    }
  },

  created () {
    if (
      (this.$store.state.cart.tickets && this.$store.state.cart.tickets.gap === GAP_GIFT_CARD) ||
      (this.$store.state.cart.events && this.$store.state.cart.events.gap === GAP_GIFT_CARD)
    ) {
      this.$store.dispatch('clearCart', { dontResetSelection: true })
    }

    this.$store.state.isReservation = false
    this.$store.state.isGiftcardOrder = false
    this.$tracking.eetInit('eticket')
    this.$tracking.track(this.$route.path, 'b')

    const currentDate = dateHelper.formatDate(dateHelper.getDate())
    this.$store.dispatch('calculateArrivalDates', { currentDate })
  },

  methods: {
    showTickets () {
      // At this point we track the *first* intend of the user to get information about certain date.

      if (!this.tracked) {
        const trackData = {
          date: this.$store.state.ticketSelection.selectedDate,
          area: 'tickets'
        }

        if (this.reservation === true) {
          trackData.area = 'reservation'
        }

        // Just send it to the backend, we don't really care if it was successful
        api.post('tracking/intent/', trackData).then(response => {
          if (response.status === 204) {
            this.tracked = true
          }
        })
      }

      this.$tracking.eetGapListView()

      scrollToArrivalTime(this)
    }
  }
}
</script>

<i18n locale="en">
{
  "title": "Ticket Booking",
  "availability": "Check availability",
  "availablePaymentOptions": "Available payment options:"
}
</i18n>

<i18n locale="de">
{
  "title": "Ticketbuchung",
  "availability": "Verfügbarkeit prüfen",
  "availablePaymentOptions": "Verfügbare Zahlungsarten:"
}
</i18n>
